module.exports = __webpack_public_path__ + "img/i-weekly-game-admin.e3e31f0c.svg";